import Api from '@/api/Api'
import store from '../store'

export default {

  async getIncomeStatement (param = '') {
    return store.dispatch('checkResponseApi', await Api().get('report/income-statement' + param))
  },

  async getPosSales (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('report/pos/sales', { params }))
  },

  async getPosCashiers (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('report/pos/cashiers', { params }))
  },

  async getPosProducts (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('report/pos/products', { params }))
  },

  async getPosProductsDetails (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('report/pos/products/details', { params }))
  },

  async getPosCategories (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('report/pos/categories', { params }))
  },

  async getPosDiningOptions (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('report/pos/dining-options', { params }))
  },

  async getPosPaymentMethods (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('report/pos/payment-methods', { params }))
  },

  async getInventoryStocks (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('report/inventory/stocks', { params }))
  },

  async getInventoryStocksSkus (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('report/inventory/stocks/skus', { params }))
  },

  async getExpenseData (path, params = {}) {
    return store.dispatch('checkResponseApi', await Api().get(`report/expense/${path}`, { params }))
  },

  async getPurchaseData (path, params = {}) {
    return store.dispatch('checkResponseApi', await Api().get(`report/purchase/${path}`, { params }))
  },

}



// WEBPACK FOOTER //
// ./src/api/ReportService.js